const pl = {
  language: {
    label: 'Język',
    polish: 'Polski',
    english: 'English',
  },
  common: {
    buttons: {
      openAssets: 'Otwórz zasoby',
      filters: 'Filtry',
      retry: 'Spróbuj ponownie',
      addDemoAsset: 'Dodaj zasób',
      view: 'Podgląd',
      close: 'Zamknij',
      keepExploring: 'Kontynuuj przeglądanie',
      printSummary: 'Drukuj podsumowanie',
      exportSample: 'Eksportuj przykład',
      createReportSchedule: 'Utwórz harmonogram raportu',
      saveChanges: 'Zapisz zmiany',
      signIn: 'Zaloguj się',
      exploreUi: 'Przeglądaj UI',
    },
    status: {
      liveFeed: 'Kanał na żywo',
      operationalActions: 'Akcje operacyjne',
      productionPreview: 'Podgląd produkcyjny',
      completed: 'Zakończone',
      needsReview: 'Wymaga sprawdzenia',
      out: 'Wydany',
      available: 'Dostępny',
      inRepair: 'W naprawie',
      reserved: 'Zarezerwowany',
      retired: 'Wycofany',
      active: 'Aktywne',
      pendingReview: 'Oczekuje na weryfikację',
      closed: 'Zamknięte',
      busy: 'Zajęte',
      operational: 'Operacyjne',
      limitedAccess: 'Ograniczony dostęp',
    },
  },
  navigation: {
    title: 'Nawigacja',
    dashboard: 'Panel',
    assets: 'Zasoby',
    scan: 'Skanowanie',
    locations: 'Lokalizacje',
    inventory: 'Inwentaryzacja',
    reports: 'Raporty',
    users: 'Użytkownicy',
    settings: 'Ustawienia',
    workspace: 'Przestrzeń robocza',
    workspaceDescription: 'Interfejs operacyjny Varibox Control Center gotowy do pracy z API.',
    productionReady: 'Gotowe produkcyjnie',
    loginScreen: 'Ekran logowania',
    appTitle: 'Varibox Control Center',
    appSubtitle: 'Centrum kontroli Varibox dla pracy na desktopie',
    searchPlaceholder: 'Szukaj zasobów, użytkowników lub lokalizacji',
    productionMode: 'Tryb produkcyjny',
    alerts: 'Alerty',
    userRole: 'Administrator operacyjny',
    workspaceLabel: 'Varibox Control Center',
  },
  login: {
    eyebrow: 'Podgląd dostępu',
    platformLabel: 'PLATFORMA OPERACYJNA',
    productTitle: 'Varibox Control Center',
    byline: 'by myZenor',
    productDescription: 'Jedno miejsce do skanowania Variboxów, obsługi lokalizacji i kontroli operacji magazynowych.',
    scanFeatureTitle: 'Skanowanie',
    scanFeatureDescription: 'Szybkie skanowanie aparatem telefonu lub czytnikiem Zebra.',
    warehouseFeatureTitle: 'Magazyny',
    warehouseFeatureDescription: 'Przypisanie Variboxa do właściwego podmagazynu PL01 lub PL99.',
    securityFeatureTitle: 'Dostęp i bezpieczeństwo',
    securityFeatureDescription: 'Osobiste konto oraz funkcje dopasowane do roli użytkownika.',
    secureAccess: 'Bezpieczny dostęp do zasobów i danych Twojej organizacji.',
    welcomeBack: 'WITAMY PONOWNIE',
    signInTitle: 'Zaloguj się',
    signInDescription: 'Wprowadź login i hasło otrzymane od administratora.',
    loginLabel: 'Login',
    passwordLabel: 'Hasło',
    submit: 'Zaloguj się',
    submitting: 'Logowanie…',
    submitError: 'Nie udało się zalogować. Spróbuj ponownie.',
    noAccount: 'Nie masz konta?',
    noAccountDescription: 'Poproś administratora o utworzenie konta i nadanie dostępu.',
    backHome: 'Strona główna',
    footerBrand: 'Varibox Control Center',
    title: 'Zaloguj się do platformy',
    description: 'Formularz jest punktem wejścia do panelu operacyjnego.',
    info: 'Uwierzytelnianie działa na kontach użytkowników w backendzie.',
    readyNow: 'Co jest gotowe',
    readyNowDescription: 'Interfejs zawiera nawigację, dashboard, tabele, ustawienia i raporty operacyjne.',
    heroTitle: 'Varibox Control Center jako dopracowany workspace do kontroli zasobów.',
    heroDescription: 'Ekran logowania prowadzi bezpośrednio do systemu po poprawnej autoryzacji.',
    snapshot: 'Migawka platformy',
    accessMode: 'Dostęp operacyjny',
    noAuth: 'autoryzacja backend działa',
    enterpriseVisibility: 'Widoczność przedsiębiorstwa',
    auditWorkflows: 'Procesy gotowe do audytu',
    roleAwareUi: 'Interfejs uwzględniający role',
    emailLabel: 'Email',
    readyState: 'Gotowe',
  },
  dashboard: {
    eyebrow: 'Panel',
    title: 'Operacje w skrócie',
    description: 'Operacyjne centrum dowodzenia dla zasobów, lokalizacji, sesji inwentaryzacji i aktywności ruchów. Widok jest przygotowany do pracy z API.',
    recentMovements: 'Ostatnie ruchy',
    recentMovementsDescription: 'Najnowsze transfery zasobów i zmiany statusu z bieżącego kanału operacyjnego.',
    quickActions: 'Szybkie akcje',
    quickActionsDescription: 'Najczęstsze skróty operacyjne dla centrum kontroli.',
    loadingPreview: 'Podgląd stanu ładowania',
    loadingPreviewDescription: 'Skeletony i wskaźniki postępu dla przyszłego pobierania danych z API.',
    loadingData: 'Ładowanie danych panelu...',
    apiError: 'Nie udało się pobrać danych panelu z API.',
    lastSync: 'Ostatnia synchronizacja 2 min temu',
    liveFeed: 'Kanał na żywo',
    totalAssets: 'Łącznie zasobów',
    availableAssets: 'Dostępne zasoby',
    assetsInRepair: 'Zasoby w naprawie',
    assetsOut: 'Zasoby wydane',
    quickActionLabels: {
      registerAssetBatch: 'Zarejestruj partię zasobów',
      scheduleInventoryRun: 'Zaplanuj inwentaryzację',
      reviewExceptionReport: 'Sprawdź raport wyjątków',
      inviteUser: 'Zaproś nowego użytkownika',
    },
    quickActionDescriptions: {
      registerAssetBatch: 'Przygotuj przyjęcie nowego stanu magazynowego.',
      scheduleInventoryRun: 'Otwórz nową sesję liczenia dla magazynu.',
      reviewExceptionReport: 'Sprawdź uszkodzone, brakujące lub przeterminowane pozycje.',
      inviteUser: 'Dodaj menedżera, operatora lub obserwatora do workspace.',
    },
    metricHelpers: {
      totalAssets: 'We wszystkich 18 aktywnych lokalizacjach',
      availableAssets: 'Gotowe do przydzielenia',
      assetsInRepair: 'Oczekują na zamknięcie serwisu',
      assetsOut: 'Wydane użytkownikom i lokalizacjom',
    },
    movementDescriptions: {
      completed: 'Przeniesiono z Warsaw Hub do Dock 3',
      needsReview: 'Oznaczono do przeglądu naprawy',
      out: 'Wydano do Project Orion',
      completedReturn: 'Zwrócono do centralnego magazynu',
    },
    movementTimestamps: {
      min12: '12 min temu',
      min34: '34 min temu',
      hour1: '1 godz. temu',
      hour2: '2 godz. temu',
    },
  },
  assets: {
    eyebrow: 'Zasoby / Variboxy',
    title: 'Zasoby / Variboxy',
    description: 'Operacyjny ekran do zarządzania wielorazowymi kontenerami Varibox z wyszukiwaniem, filtrami, statystykami i podglądem historii.',
    searchLabel: 'Szukaj Variboxów',
    searchPlaceholder: 'Numer seryjny, RADEX, kod kreskowy, RFID, klient lub lokalizacja',
    searchHint: 'Wpisz kilka słów — mogą pasować do różnych pól tego samego Variboxa.',
    buttons: {
      addVaribox: 'Dodaj Varibox',
      scanVaribox: 'Skanuj Varibox',
      editSelected: 'Edytuj zaznaczony',
      export: 'Eksportuj',
      viewHistory: 'Zobacz historię',
      clearFilters: 'Wyczyść filtry',
      clearSearch: 'Wyczyść wyszukiwanie',
      clientBalance: 'Saldo klienta / PDF',
    },
    preview: 'Podgląd Variboxa',
    stats: {
      all: 'Wszystkie',
      available: 'Wolne',
      occupied: 'Zajęte',
      repair: 'W naprawie',
      blocked: 'Zablokowane',
    },
    menu: {
      details: 'Szczegóły',
      history: 'Historia',
      edit: 'Edytuj',
      block: 'Zablokuj',
      delete: 'Usuń',
    },
    filters: {
      status: 'Status',
      client: 'Klient',
      capacity: 'Pojemność',
      sealType: 'Rodzaj uszczelnienia',
      contract: 'Umowa',
      location: 'Lokalizacja',
      locationFromMap: 'Widok z mapy klienta',
      all: 'Wszystkie',
      yes: 'Tak',
      no: 'Nie',
    },
    emptyState: {
      title: 'Brak wyników dla wybranych filtrów',
      description: 'Zmień kryteria wyszukiwania albo usuń filtry, żeby zobaczyć dostępne Variboxy.',
    },
    loadingData: 'Ładowanie danych Varibox...',
    loadingDetails: 'Ładowanie szczegółów Variboxa...',
    apiError: 'Nie udało się pobrać danych Varibox z API.',
    delete: {
      confirm: 'Czy na pewno chcesz usunąć Varibox',
      success: 'Usunięto Varibox',
      error: 'Nie udało się usunąć Variboxa.',
      bulkButton: 'Usuń zaznaczone ({count})',
      bulkConfirm: 'Czy na pewno chcesz usunąć zaznaczone Variboxy? Liczba: {count}',
      bulkSuccess: 'Usunięto Variboxy: {count}',
      bulkError: 'Nie udało się usunąć zaznaczonych Variboxów.',
      selectAll: 'Zaznacz wszystkie widoczne Variboxy',
      selectOne: 'Zaznacz Varibox do usunięcia',
    },
    detailsApiError: 'Nie udało się pobrać szczegółów Variboxa.',
    historyUnavailable: 'Historia ruchów nie jest jeszcze dostępna z API.',
    quickStatsLabels: {
      all: 'Wszystkie',
      available: 'Wolne',
      occupied: 'Zajęte',
      repair: 'W naprawie',
      blocked: 'Zablokowane',
    },
    headings: {
      serialNumber: 'Numer seryjny',
      radexId: 'Numer identyfikacyjny RADEX',
      capacity: 'Pojemność [L]',
      bodyColor: 'Kolor obudowy',
      sealType: 'Rodzaj uszczelnienia',
      status: 'Status',
      client: 'Klient',
      contract: 'Umowa',
      rfid: 'RFID',
      actions: 'Akcje',
    },
    statuses: {
      available: 'wolny',
      occupied: 'zajęty',
      damaged: 'uszkodzony',
      repair: 'naprawa',
      cleaning: 'mycie',
      blocked: 'zablokowany',
    },
    contractValues: {
      tak: 'tak',
      nie: 'nie',
    },
    variboxDetails: {
      title: 'Szczegóły Variboxa',
      editData: 'Edytuj dane Variboxa',
      capacity: 'Pojemność',
      color: 'Kolor',
      seal: 'Uszczelnienie',
      client: 'Klient',
      contract: 'Umowa',
      lastLocation: 'Ostatnia lokalizacja',
      lastMovement: 'Ostatni ruch',
      qrTitle: 'Kod QR do skanowania',
      qrDescription: 'Kod zawiera identyfikator Variboxa i jego dane techniczne. Zeskanowanie otworzy aktualne dane z systemu.',
      qrGenerate: 'Generuj kod QR',
      qrHide: 'Ukryj kod QR',
      qrPrint: 'Drukuj etykietę',
      qrPopupBlocked: 'Przeglądarka zablokowała okno drukowania. Zezwól na wyskakujące okna i spróbuj ponownie.',
      historyTitle: 'Historia Variboxa',
      historyDescription: 'Historia ruchów, mycia, napraw i wydań Variboxa.',
      adminTitle: 'Panel admina',
      adminDescription: 'Z poziomu szczegółów możesz aktywować Varibox i przypisać lokalizację magazynową.',
      locationLabel: 'Lokalizacja',
      locationPlaceholder: 'Wybierz lokalizację',
      rootLocationLabel: 'Magazyn główny',
      rootLocationPlaceholder: 'Wybierz PL01 lub PL99',
      sublocationLabel: 'Podmagazyn / podlokalizacja',
      sublocationSelectRootHint: 'Najpierw wybierz magazyn główny, aby zobaczyć podmagazyny.',
      sublocationNoOptionsHint: 'Dla wybranego magazynu głównego nie ma jeszcze zdefiniowanych podmagazynów.',
      sublocationKeepRoot: 'Pozostaw w magazynie głównym',
      activateAndSave: 'Aktywuj i zapisz',
      saveLocation: 'Zapisz lokalizację',
      adminSaved: 'Zapisano zmiany Variboxa.',
      adminSaveError: 'Nie udało się zapisać zmian Variboxa.',
      adminNoChanges: 'Brak zmian do zapisania.',
    },
    createDialog: {
      title: 'Dodaj Varibox do bazy',
      description: 'Wypełnij wymagane pola, aby utworzyć nowy rekord przez API.',
      serialNumber: 'Numer seryjny',
      radexIdentifier: 'Numer RADEX',
      barcode: 'Kod kreskowy',
      capacity: 'Pojemność [L]',
      color: 'Kolor',
      sealType: 'Rodzaj uszczelnienia',
      status: 'Status',
      contract: 'Umowa',
      client: 'Klient',
      clientPlaceholder: 'Wybierz klienta, jeśli rekord ma być przypisany',
      noClients: 'Brak dostępnych klientów',
      noClient: 'Bez przypisania',
      rfidTag: 'Tag RFID',
      rfidTagHelp: 'Opcjonalne pole dla tagu RFID.',
      notes: 'Notatki',
      save: 'Zapisz do bazy',
      saving: 'Zapisywanie...',
      checkingDuplicates: 'Sprawdzanie numerów...',
      duplicateWarning: 'Co najmniej jeden numer jest już przypisany do innego Variboxa.',
      duplicateCheckError: 'Nie udało się sprawdzić numerów. Zapis zostanie dodatkowo zweryfikowany przez serwer.',
      duplicateSerial: 'Ten numer seryjny jest już używany.',
      duplicateRadex: 'Ten numer RADEX jest już używany.',
      duplicateBarcode: 'Ten kod kreskowy jest już używany.',
      error: 'Nie udało się utworzyć Variboxa.',
    },
    editDialog: {
      title: 'Edytuj dane Variboxa',
      description: 'Zmień dane kontenera. Zmiany zapisują się w systemie po potwierdzeniu.',
      loadError: 'Nie udało się pobrać danych do edycji Variboxa.',
      error: 'Nie udało się zapisać zmian Variboxa.',
      duplicateSerial: 'Numer seryjny jest już przypisany do innego Variboxa.',
      duplicateRadex: 'Numer RADEX jest już przypisany do innego Variboxa.',
      duplicateBarcode: 'Kod kreskowy jest już przypisany do innego Variboxa.',
      duplicateWarning: 'Co najmniej jeden numer jest już przypisany do innego Variboxa.',
      checkingDuplicates: 'Sprawdzanie numerów...',
      duplicateCheckError: 'Nie udało się sprawdzić numerów. Zapis zostanie dodatkowo zweryfikowany przez serwer.',
      location: 'Lokalizacja',
      keepLocation: 'Pozostaw obecną lokalizację',
      save: 'Zapisz zmiany',
      saving: 'Zapisywanie...',
    },
  },
  scan: {
    eyebrow: 'Skanowanie',
    title: 'Skanuj Varibox',
    description: 'Szybki ekran do pracy z kodem kreskowym z klawiatury, skanerem Zebra i aparatem telefonu.',
    mobile: {
      title: 'Skanuj Varibox',
      description: 'Naciśnij przycisk i skieruj aparat na kod. Wynik pojawi się od razu.',
      cameraButton: 'Otwórz skaner aparatem',
      manualButton: 'Wpisz kod ręcznie',
      nextScan: 'Skanuj następny Varibox',
    },
    scanNowTitle: 'Gotowy do skanowania',
    scanNowDescription: 'Zeskanuj kod kreskowy i naciśnij Enter. Zebra działa jak klawiatura.',
    helper: 'Pole wejściowe ma fokus, więc możesz od razu zeskanować lub wpisać kod ręcznie.',
    barcodeLabel: 'Kod kreskowy',
    barcodePlaceholder: 'Zeskanuj lub wpisz numer seryjny Variboxa',
    keyboardHint: 'Skaner Zebra może działać jak klawiatura. Po kodzie naciśnij Enter.',
    lastBarcodeLabel: 'Ostatnio zeskanowany kod',
    waitingState: 'Czekam na skan',
    waitingHint: 'Pole wejściowe ma fokus, więc możesz od razu zeskanować lub wpisać kod ręcznie.',
    scanningMessage: 'Skanowanie...',
    foundMessage: 'Znaleziono Variboxa',
    notFoundMessage: 'Nie znaleziono Variboxa',
    errorMessage: 'Wystąpił błąd podczas skanowania',
    unknownTitle: 'Nie znaleziono Variboxa',
    unknownDescription: 'Kod nie istnieje w bazie. Spróbuj ponownie lub wpisz go ręcznie. Nowy Varibox może dodać administrator.',
    foundPanelTitle: 'Wynik skanowania',
    foundPanelDescription: 'Po wykryciu wyświetlamy pełny podgląd wybranego Variboxa.',
    quickActionsTitle: 'Szybkie akcje',
    historyTitle: 'Ostatnie skany',
    historyDescription: 'Historia bieżącej sesji skanowania przechowywana wyłącznie po stronie frontendu.',
    historyEmpty: 'Brak skanów w bieżącej sesji.',
    notFoundHistoryValue: 'Nie znaleziono',
    buttons: {
      scan: 'Skanuj',
      manual: 'Wprowadź ręcznie',
      camera: 'Użyj aparatu',
      cancel: 'Anuluj / Wróć',
      retry: 'Spróbuj ponownie',
      nextScan: 'Skanuj następny',
      viewMovementHistory: 'Zobacz historię',
      addVaribox: 'Dodaj Varibox',
      details: 'Szczegóły',
      history: 'Historia',
      issue: 'Wydaj',
      receive: 'Przyjmij',
      block: 'Zablokuj',
    },
    status: {
      ready: 'Gotowy do skanowania',
      scanning: 'Skanowanie...',
      found: 'Znaleziono',
      notFound: 'Nie znaleziono',
      error: 'Błąd',
    },
    historyResults: {
      found: 'Znaleziono',
      notFound: 'Nie znaleziono',
      error: 'Błąd',
    },
    availability: {
      enabled: 'Dostępny operacyjnie',
      disabled: 'Wyłączony z użytkowania',
    },
    locations: {
      PL01: 'Centrala operacyjna',
      PL99: 'Lokalizacje klienta',
    },
    sublocations: {
      magazyn: 'Magazyn',
      naprawa: 'Naprawa',
      mycie: 'Mycie',
      uszkodzone: 'Uszkodzone',
      cedrob: 'Cedrob',
      grot: 'Grot',
      prosziaczek: 'Prosziaczek',
    },
    movement: {
      currentLocation: 'Aktualna lokalizacja',
      destinationLocation: 'Lokalizacja docelowa',
      destinationOption: 'Podlokalizacja / klient',
      selectDestination: 'Wybierz lokalizację docelową',
      selectDestinationOption: 'Wybierz podlokalizację lub klienta',
      suggestedDestination: 'Sugerowany kierunek zwrotu',
      note: 'Notatka (opcjonalna)',
      notePlaceholder: 'Dodaj komentarz do przemieszczenia (np. zwrot po myciu)',
      addPhoto: 'Dodaj zdjęcie (opcjonalne)',
      removePhoto: 'Usuń zdjęcie',
      photoHint: 'Zdjęcie pozostaje wyłącznie w stanie roboczym frontendu i nie jest wysyłane do backendu.',
      adminCorrectionHint: 'Ruchy mogą zostać później skorygowane przez Administratora. Na tym etapie to wyłącznie workflow roboczy.',
      successTitle: 'Przemieszczenie zapisane',
      successDescription: 'Ruch został zapisany natychmiast po wyborze miejsca docelowego.',
      previousLocation: 'Poprzednia lokalizacja',
      dateTime: 'Data i czas',
      availability: 'Dostępność',
      user: 'Użytkownik',
      photo: 'Podgląd zdjęcia',
      historyTitle: 'Historia przemieszczeń',
      historyDescription: 'Ostatnie ruchy zapisane w lokalnym stanie roboczym.',
      historyEmpty: 'Brak zapisanych przemieszczeń w tej sesji.',
    },
    assign: {
      title: 'Przypisz po skanowaniu',
      description: 'Po skanie wybierz magazyn główny i podmagazyn, a potem zapisz lokalizację Variboxa.',
      chooseSubwarehouse: 'Wybierz podmagazyn',
      saveAndNext: 'Zapisz lokalizację',
      saving: 'Zapisywanie lokalizacji…',
      saved: 'Zapisano lokalizację Variboxa.',
      noChanges: 'Nie wykryto zmian lokalizacji.',
      error: 'Nie udało się zapisać lokalizacji.',
    },
    workflowActions: {
      camera: 'Aparat telefonu został uruchomiony.',
      add: 'Dodawanie Variboxa otwiera formularz zapisu do bazy.',
      issue: 'Wydawanie Variboxa zostanie podłączone do workflow.',
      receive: 'Przyjęcie Variboxa zostanie podłączone do workflow.',
      block: 'Blokowanie Variboxa zostanie podłączone do workflow.',
    },
    camera: {
      title: 'Skanuj aparatem telefonu',
      description: 'Skieruj aparat na kod. Aplikacja spróbuje odczytać go automatycznie.',
      modeLabel: 'Wybierz typ skanowanego kodu',
      barcodeMode: 'Kod kreskowy',
      qrMode: 'Kod QR',
      barcodeDescription: 'Tryb odczytuje kody kreskowe 1D i pomija QR. Skieruj aparat na kod pod numerem seryjnym.',
      qrDescription: 'Tryb odczytuje wyłącznie kod QR.',
      loading: 'Uruchamianie kamery...',
      tip: 'Jeśli przeglądarka nie obsługuje skanowania z kamery, użyj ręcznego wpisania lub skanera Zebra.',
      unavailable: 'Twoja przeglądarka nie udostępnia skanowania z kamery.',
      close: 'Zamknij',
      restart: 'Uruchom ponownie',
    },
  },
  locations: {
    eyebrow: 'Lokalizacje',
    title: 'Magazyny i obiekty operacyjne',
    description: 'Wizualna mapa sieci Varibox Control Center. Każda karta pokazuje zajętość, właściciela i bieżący status operacyjny.',
    treeTitle: 'Drzewo lokalizacji Varibox',
    treeDescription: 'Szybki podgląd gdzie znajdują się kontenery Varibox wraz z licznikami i listą kontenerów w wybranym węźle.',
    treeSectionTitle: 'Struktura lokalizacji',
    countSuffix: 'Variboxów',
    selectHint: 'Wybierz lokalizację lub podlokalizację z drzewa, aby zobaczyć kontenery.',
    emptyNode: 'Brak Variboxów w wybranej lokalizacji.',
    loadingData: 'Ładowanie drzewa lokalizacji...',
    apiError: 'Nie udało się pobrać lokalizacji z API.',
    lastMovement: 'Ostatni ruch',
    actions: {
      scanVaribox: 'Skanuj Varibox',
      searchVaribox: 'Szukaj Varibox',
      inventory: 'Inwentaryzacja',
    },
    overview: {
      total: 'Łącznie',
      available: 'Wolne',
      occupied: 'Zajęte',
      repair: 'Naprawa',
      blocked: 'Zablokowane',
    },
    mobile: {
      title: 'Lokalizacje Varibox',
      description: 'Mobilny podgląd lokalizacji i kontenerów z priorytetem dla szybkiego skanowania.',
      variboxCount: 'Variboxów',
      openLocation: 'Otwórz',
      openList: 'Pokaż listę',
      backToRoots: 'Wróć do lokalizacji głównych',
      recentScans: 'Ostatnie skany',
      noRecentScans: 'Brak ostatnich skanów.',
    },
    supervisor: 'Opiekun',
    occupancy: 'Zajętość',
    capacityUsed: 'wykorzystanej pojemności',
    demoRecord: 'Rekord lokalizacji',
    categories: {
      primaryWarehouse: 'Główny magazyn',
      regionalDepot: 'Depo regionalne',
      repairInspection: 'Naprawy i przeglądy',
      overflowHub: 'Bufor nadmiarowy',
    },
    notes: {
      mainDispatch: 'Główny hub wysyłek i zwrotów dla codziennych operacji.',
      coastalShipments: 'Obsługuje wysyłki przybrzeżne i szybkie zlecenia.',
      maintenanceArea: 'Dedykowany obszar napraw dla uszkodzonych lub przeterminowanych zasobów.',
      seasonalBuffer: 'Elastyczny bufor na sezonowe skoki popytu i nowy przyjęty towar.',
    },
    adminPanel: {
      title: 'Panel podmagazynów',
      description: 'Dodaj podmagazyn lub węzeł klienta pod wybranym magazynem głównym (np. PL01 lub PL99).',
      parentLabel: 'Magazyn nadrzędny',
      kindLabel: 'Typ węzła',
      kindSublocation: 'Podmagazyn',
      kindClientNode: 'Węzeł klienta',
      nameLabel: 'Nazwa podmagazynu / firmy',
      codeLabel: 'Kod (opcjonalnie)',
      addressLabel: 'Adres firmy',
      postalCodeLabel: 'Kod pocztowy',
      cityLabel: 'Miejscowość',
      cityCodeLabel: 'Kod miejscowości (opcjonalnie)',
      companyProfileHint: 'Dla gałęzi PL01 lub PL99 dodaj dane firmy i adres, aby pokazać punkt na mapie Polski.',
      companyProfileOnlyHint: 'Dane firmy i adres są dostępne w gałęziach PL01 i PL99.',
      companyProfileRequiredHint: 'Dla PL01 lub PL99 podaj adres, kod pocztowy i miejscowość.',
      createButton: 'Dodaj podmagazyn',
      creating: 'Dodawanie...',
      created: 'Podmagazyn został dodany.',
      createError: 'Nie udało się dodać podmagazynu.',
    },
    map: {
      title: 'Mapa firm — PL01 i PL99',
      description: 'Lokalizacje firm przypisanych do gałęzi PL01 i PL99 na mapie Polski.',
      loading: 'Wczytywanie punktów na mapie...',
      empty: 'Brak punktów firmowych do pokazania na mapie.',
      selectedClientCount: 'Liczba Variboxów klienta',
      goToClientState: 'Przejdź do stanu klienta',
      markerSublocation: 'Podmagazyn',
      markerClientNode: 'Węzeł klienta',
    },
  },
  inventory: {
    eyebrow: 'Inwentaryzacja',
    sessionTitle: 'Sesja inwentaryzacji lokalizacji',
    sessionDescription: 'Frontendowy workflow skanowania dla wybranej lokalizacji: expected, unexpected, missing, podsumowanie i historia sesji.',
    title: 'Sesje inwentaryzacyjne',
    description: 'Widok sesji do zliczania stanu, obsługi wyjątków i statusu sesji inwentaryzacji.',
    startTitle: 'Rozpocznij sesję inwentaryzacji',
    activeSessionTitle: 'Aktywna sesja skanowania',
    historyTitle: 'Historia sesji inwentaryzacji',
    apiError: 'Nie udało się pobrać lokalizacji i Variboxów do inwentaryzacji.',
    noLocationSelected: 'Brak wybranej lokalizacji',
    locationCodeLabel: 'Kod lokalizacji',
    locationOptionLabel: 'Podlokalizacja / klient',
    selectLocationCode: 'Wybierz kod lokalizacji',
    selectLocationOption: 'Wybierz podlokalizację lub klienta',
    rootLocationFallback: 'Ta lokalizacja nie ma podlokalizacji — inwentaryzacja obejmie wybraną lokalizację główną.',
    locationLabel: 'Lokalizacja inwentaryzacji',
    currentLocationLabel: 'Aktualna lokalizacja kontenera',
    inventoryLocationLabel: 'Lokalizacja sesji inwentaryzacji',
    scannerTitle: 'Skaner kodów kreskowych',
    camera: {
      title: 'Skanuj aparatem',
      modeLabel: 'Wybierz typ skanowanego kodu',
      barcodeMode: 'Kod kreskowy',
      qrMode: 'Kod QR',
      barcodeDescription: 'Odczytuje kody kreskowe 1D i pomija QR.',
      qrDescription: 'Odczytuje wyłącznie kod QR.',
      loading: 'Uruchamianie kamery...',
      unavailable: 'Nie udało się uruchomić kamery. Sprawdź uprawnienia przeglądarki.',
      close: 'Zamknij',
    },
    barcodeLabel: 'Kod kreskowy',
    barcodePlaceholder: 'Skanuj kod z czytnika Zebra lub wpisz ręcznie',
    counters: {
      expected: 'Oczekiwane',
      scanned: 'Zeskanowane',
      found: 'Znalezione',
      unexpected: 'Nieoczekiwane',
      missing: 'Brakujące',
    },
    results: {
      foundTitle: 'Zgodny z lokalizacją inwentaryzacji',
      unexpectedTitle: 'Niezgodna lokalizacja kontenera',
      unexpectedDescription: 'Kontener zeskanowany, ale aktualnie znajduje się w innej lokalizacji.',
      duplicate: 'Duplikat skanu',
      unknown: 'Nieznany kod',
    },
    summary: {
      title: 'Podsumowanie zakończonej sesji',
      foundList: 'Lista znalezionych',
      unexpectedList: 'Lista nieoczekiwanych',
      missingList: 'Lista brakujących',
    },
    history: {
      location: 'Lokalizacja',
      date: 'Data zakończenia',
      progress: 'Wynik',
      missing: 'Braki',
      status: 'Status',
      missingSuffix: 'br.',
    },
    historyEmpty: 'Brak zakończonych sesji inwentaryzacji.',
    sessionStatus: {
      completed: 'Zakończona',
    },
    buttons: {
      startScanning: 'Start skanowania',
      scanNext: 'Skanuj następny',
      scanVariboxMobile: 'Skanuj Varibox',
      scanWithCamera: 'Skanuj aparatem',
      finishInventory: 'Zakończ inwentaryzację',
      newSession: 'Nowa sesja',
      closeSession: 'Zamknij',
    },
    activeSession: 'Aktywna sesja',
    itemsCounted: 'Policzono pozycje',
    exceptions: 'Wyjątki',
    sessionProgress: 'Postęp sesji',
    workflowPreview: 'Podgląd procesu inwentaryzacji',
    countCollection: 'Zbieranie zliczeń',
    countCollectionDescription: 'Operatorzy skanują i potwierdzają kody kreskowe zasobów.',
    exceptionReview: 'Przegląd wyjątków',
    exceptionReviewDescription: 'Brakujące lub nadmiarowe pozycje są oznaczane do wyjaśnienia.',
    sessionCloseout: 'Zamykanie sesji',
    sessionCloseoutDescription: 'Raporty są przygotowywane do zatwierdzenia i archiwizacji.',
    sessionItems: 'pozycji',
    sessionNames: {
      augustAudit: 'Sierpniowy audyt magazynu',
      coastalCount: 'Licznik cykliczny depo przybrzeżnego',
      repairVerification: 'Weryfikacja strefy napraw',
    },
    sessionStatusLabels: {
      inProgress: 'W trakcie',
      pendingReview: 'Oczekuje na przegląd',
      closed: 'Zamknięte',
    },
    sessionStartedAt: {
      today0630: 'Rozpoczęto dziś o 06:30',
      yesterday1815: 'Zakończono wczoraj o 18:15',
      aug07: 'Zamknięto 7 sie',
    },
  },
  clientBalance: {
    eyebrow: 'Karta klienta',
    title: 'Saldo Variboxów',
    description: 'Formalne zestawienie Variboxów przypisanych do odbiorcy, z danymi firmy, adresem i numerami seryjnymi.',
    loadError: 'Nie udało się pobrać salda klienta.',
    backToAssets: 'Wróć do zasobów',
    exportPdf: 'Zapisz jako PDF',
    generatedAt: 'Stan na',
    recipient: 'Dane odbiorcy',
    statementLabel: 'Opakowania zwrotne powierzone odbiorcy',
    statementTitle: 'Wezwanie do zwrotu / uzgodnienia salda',
    reference: 'Lokalizacja / odbiorca',
    statementDate: 'Data zestawienia',
    returnRequestTitle: 'Prośba o zwrot lub uzgodnienie salda',
    returnRequest: 'Według ewidencji poniższe opakowania Varibox pozostają powierzone odbiorcy. Prosimy o niezwłoczny zwrot wskazanych kontenerów albo o pilny kontakt w celu uzgodnienia salda i wyjaśnienia ewentualnych rozbieżności. Przy zwrocie należy powołać się na numery seryjne wymienione w zestawieniu.',
    currentStock: 'Variboxy na stanie',
    variboxUnit: 'aktualnie przypisane do klienta',
    recordedDays: 'Dni pobytu z historią',
    recordedDaysNote: 'Suma dni aktualnych pobytów z dostępnych zapisów',
    missingHistory: 'Bez daty rozpoczęcia',
    missingHistoryNote: 'Brak zapisanego wejścia do lokalizacji klienta',
    detailsTitle: 'Szczegółowe saldo kontenerów',
    detailsDescription: 'Lista bieżących Variboxów przypisanych do klienta.',
    serialNumber: 'Numer seryjny',
    status: 'Status',
    location: 'Lokalizacja',
    since: 'U klienta od',
    days: 'Dni',
    noHistory: 'Brak danych',
    empty: 'Brak Variboxów przypisanych do tego klienta.',
    calculationNote: 'Zestawienie odzwierciedla bieżące przypisanie w ewidencji i służy do uzgodnienia salda. Czas pobytu jest liczony wyłącznie z zapisanej historii ruchów; dla starszych przypisań data rozpoczęcia może być niedostępna.',
  },
  reports: {
    eyebrow: 'Raporty',
    title: 'Raportowanie operacyjne',
    description: 'Sprawdź, ile razy każdy Varibox zmieniał lokalizację, przeanalizuj trendy i pobierz szczegółowy raport Excel.',
    period: 'Zakres raportu',
    fromDate: 'Od dnia',
    toDate: 'Do dnia',
    totalMoves: 'Wszystkie ruchy',
    variboxesMoved: 'Variboxy w ruchu',
    averageMoves: 'Średnio ruchów na Varibox',
    movementTrendTitle: 'Ruchy w czasie',
    movementTrendDescription: 'Liczba zmian lokalizacji w wybranym okresie.',
    mostMovedTitle: 'Najczęściej przenoszone Variboxy',
    mostMovedDescription: 'Ranking według liczby zarejestrowanych zmian lokalizacji.',
    searchVaribox: 'Znajdź Varibox po numerze seryjnym lub RADEX',
    noMatchingVaribox: 'Brak ruchów dla Variboxa pasującego do wyszukiwania.',
    latestMovementsTitle: 'Ostatnie ruchy',
    latestMovementsDescription: 'Historia przeniesień z lokalizacją źródłową i docelową.',
    serialNumber: 'Numer seryjny',
    radex: 'RADEX',
    moveCount: 'Liczba ruchów',
    dateTime: 'Data i godzina',
    route: 'Trasa',
    actor: 'Wykonał',
    exportExcel: 'Pobierz Excel',
    exporting: 'Przygotowywanie…',
    exportSuccess: 'Raport Excel został pobrany.',
    exportError: 'Nie udało się przygotować pliku Excel.',
    loadError: 'Nie udało się pobrać danych raportu.',
    noMovementData: 'Brak zarejestrowanych ruchów w tym okresie.',
    historyStartsNotice: 'Historia ruchów jest rejestrowana od momentu wdrożenia tej funkcji; wcześniejszych przeniesień nie da się odtworzyć.',
    printSummary: 'Drukuj podsumowanie',
    exportSample: 'Eksportuj przykład',
    reportDelivery: 'Proces dostarczania raportów',
    reportDeliveryDescription: 'Proces zaplanowanych eksportów, dystrybucji mailowej i etapów akceptacji.',
    scheduledExports: 'Zaplanowane eksporty',
    approvedReports: 'Zatwierdzone raporty',
    emptyState: 'Podgląd pustego stanu',
    emptyStateDescription: 'Niektóre typy raportów nie mają jeszcze zapisanych harmonogramów. UI nadal powinien wyglądać kompletnie.',
    noReports: 'Brak skonfigurowanych raportów własnych',
    emptyStateHint: 'Dodaj harmonogram później, aby automatycznie generować wyjścia dla zespołu.',
    createReportSchedule: 'Utwórz harmonogram raportu',
    cards: {
      inventoryBalance: {
        title: 'Bilans inwentarza',
        description: 'Bieżący stan, straty i korekty według lokalizacji.',
        accent: 'Podstawowy wskaźnik zdrowia',
        actionLabel: 'Otwórz przykładowy raport',
      },
      movementTrend: {
        title: 'Trend ruchu',
        description: 'Transfery, przyjęcia i wydania w ciągu tygodnia.',
        accent: 'Trend operacyjny',
        actionLabel: 'Sprawdź dziennik ruchu',
      },
      repairBacklog: {
        title: 'Zaległości napraw',
        description: 'Otwarte przypadki serwisowe i szacowany czas zamknięcia.',
        accent: 'Kolejka serwisowa',
        actionLabel: 'Przejrzyj kolejkę napraw',
      },
    },
  },
  users: {
    eyebrow: 'Użytkownicy',
    title: 'Role i podgląd dostępu',
    description: 'Rekordy użytkowników z etykietami ról, właścicielem zespołu i statusem dostępu.',
    totalUsers: 'Łącznie użytkowników',
    activeAdmins: 'Aktywni administratorzy',
    viewerAccounts: 'Konta obserwatorów',
    headings: {
      user: 'Użytkownik',
      email: 'Email',
      role: 'Rola',
      team: 'Zespół',
      status: 'Status',
      lastSeen: 'Ostatnia aktywność',
    },
    roles: {
      admin: 'Administrator',
      manager: 'Menedżer',
      user: 'Użytkownik',
      viewer: 'Obserwator',
    },
    summaries: {
      totalUsers: 'Liczba kont użytkowników dostępnych w systemie.',
      activeAdmins: 'Administracja przestrzenią roboczą i kontrola polityk.',
      viewerAccounts: 'Tylko do odczytu, dla audytu i nadzoru.',
    },
  },
  settings: {
    eyebrow: 'Ustawienia',
    title: 'Ustawienia przestrzeni roboczej',
    description: 'Obszar konfiguracji przestrzeni roboczej i preferencji systemu.',
    saveDraft: 'Zapisz wersję roboczą',
    info: 'Część ustawień działa lokalnie i będzie dalej rozszerzana po stronie backendu.',
    general: 'Ogólne',
    language: 'Język',
    appearance: 'Wygląd',
    notifications: 'Powiadomienia',
    applicationInfo: 'Informacje o aplikacji',
    workspaceName: 'Nazwa przestrzeni',
    timezone: 'Strefa czasowa',
    allowInvites: 'Zezwalaj na zaproszenia',
    requireApproval: 'Wymagaj akceptacji menedżera dla zmian dostępu',
    sessionTimeoutWarnings: 'Ostrzeżenia o wygasaniu sesji',
    maintenanceReminders: 'Przypomnienia o naprawach',
    transferNotifications: 'Powiadomienia o transferach',
    executiveDigest: 'Podsumowanie dla zarządu',
    retentionPeriod: 'Okres retencji',
    exportWindow: 'Okno eksportu',
    saveSettings: 'Zapisz ustawienia',
    currentLanguage: 'Aktualny język',
    languageDescription: 'Wybrany język jest zapisywany lokalnie i pozostaje po odświeżeniu strony.',
    appearanceDescription: 'Zachowujemy obecny styl Material UI i ulepszamy go bez przebudowy wizualnej.',
    generalDescription: 'Podstawowe ustawienia przestrzeni roboczej i domyślne preferencje.',
    notificationsDescription: 'Skonfiguruj, które zdarzenia będą widoczne w podglądzie.',
    appInfoDescription: 'Wersja wizualnego MVP i informacje o środowisku.',
    appName: 'Varibox Control Center',
    appVersion: 'Wersja',
    architecture: 'Architektura',
    architectureValue: 'V3 zamrożona',
    stack: 'Stack',
    stackValue: 'React + TypeScript + Material UI',
    versionValue: 'Wersja produkcyjna',
    appearanceOptions: {
      compactTableDensity: 'Kompaktowa gęstość tabeli',
      stickyHeader: 'Przyklejony nagłówek',
      highContrastAccents: 'Akcenty o wysokim kontraście',
    },
    helperTexts: {
      timezone: 'UTC, Europe/Warsaw, Europe/London',
      currentLanguage: 'Wybór zapisuje się w localStorage i od razu się stosuje.',
      appearance: 'Aktualny styl Material UI pozostaje bez zmian.',
      notifications: 'Sterowanie powiadomieniami zostanie połączone z backendem w kolejnym kroku.',
    },
    createDialog: {
      title: 'Dodaj Varibox do bazy',
      description: 'Wypełnij wymagane pola, aby utworzyć nowy rekord przez API.',
      serialNumber: 'Numer seryjny',
      radexIdentifier: 'Numer RADEX',
      barcode: 'Kod kreskowy',
      capacity: 'Pojemność [L]',
      color: 'Kolor',
      sealType: 'Rodzaj uszczelnienia',
      status: 'Status',
      contract: 'Umowa',
      client: 'Klient',
      clientPlaceholder: 'Wybierz klienta, jeśli rekord ma być przypisany',
      noClients: 'Brak dostępnych klientów',
      noClient: 'Bez przypisania',
      rfidTag: 'Tag RFID',
      rfidTagHelp: 'Opcjonalne pole dla tagu RFID.',
      notes: 'Notatki',
      save: 'Zapisz do bazy',
      saving: 'Zapisywanie...',
      error: 'Nie udało się utworzyć Variboxa.',
    },
    import: {
      title: 'Import Varibox z Excel',
      description: 'Załaduj plik .xlsx, wykonaj walidację i następnie import do bazy danych.',
      chooseFile: 'Wybierz plik .xlsx',
      validateButton: 'Waliduj plik',
      importButton: 'Importuj dane',
      validating: 'Walidacja...',
      importing: 'Importowanie...',
      validationPassed: 'Walidacja zakończona sukcesem. Możesz uruchomić import.',
      validationFailed: 'Walidacja wykryła błędy. Import nie zostanie wykonany.',
      reportTitle: 'Raport walidacji',
      totalRows: 'Wiersze łącznie',
      importableRows: 'Wiersze gotowe do importu',
      imported: 'Zaimportowane',
      skippedExisting: 'Pominięte (już istnieją)',
      errors: 'Błędy',
      row: 'Wiersz',
      clientsCreated: 'Nowi klienci',
      clientsReused: 'Wykorzystani klienci istniejący',
      pl01Count: 'Przypisane do PL01',
      pl99Count: 'Przypisane do PL99',
      importFinished: 'Import zakończony.',
      uploadFailed: 'Nie udało się przesłać lub przetworzyć pliku.',
    },
  },

  loginDetails: {
    team: 'Zespół',
  },
} as const;

export default pl;